import { render, staticRenderFns } from "./AddPayment.vue?vue&type=template&id=2fb68f0c&scoped=true"
import script from "./AddPayment.vue?vue&type=script&lang=js"
export * from "./AddPayment.vue?vue&type=script&lang=js"
import style0 from "./AddPayment.vue?vue&type=style&index=0&id=2fb68f0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb68f0c",
  null
  
)

export default component.exports